import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { Cpu, ChevronRight } from "lucide-react";

const nav = [
  { to: "/", label: "Overview", end: true },
  { to: "/start", label: "Start Project" },
  { to: "/validated-demo", label: "Validated Demo" },
  { to: "/investor", label: "Investor Demonstration" },
  { to: "/pilot", label: "Request Pilot" },
];

export default function Layout() {
  const navigate = useNavigate();
  const adminToken = typeof window !== "undefined" && localStorage.getItem("aiude_admin_token");
  return (
    <div className="min-h-screen flex flex-col">
      <header className="no-print sticky top-0 z-40 backdrop-blur-md bg-[#070B12]/85 border-b border-[#1E2F48]">
        <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center gap-8">
          <Link to="/" data-testid="brand-home" className="flex items-center gap-3 group">
            <div className="w-9 h-9 border border-[#00D2FF] flex items-center justify-center bg-[#0B111C] group-hover:bg-[#111A29] transition">
              <Cpu className="w-4 h-4 text-[#00D2FF]" />
            </div>
            <div className="leading-tight">
              <div className="text-white font-semibold tracking-wider text-sm">A.I.U.D.E.</div>
              <div className="font-tech text-[9px]">Universal Design Engine</div>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1 ml-4">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm tracking-wide transition border-b-2 ${
                    isActive
                      ? "text-[#00D2FF] border-[#00D2FF]"
                      : "text-slate-300 border-transparent hover:text-white hover:border-[#1E2F48]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2">
            {adminToken ? (
              <button
                data-testid="admin-open-btn"
                onClick={() => navigate("/admin")}
                className="btn-ghost text-xs"
              >
                Admin Console <ChevronRight className="w-3 h-3" />
              </button>
            ) : (
              <Link to="/admin/login" data-testid="admin-login-btn" className="btn-ghost text-xs">
                Admin
              </Link>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-[1400px] w-full mx-auto px-6 py-10">
        <Outlet />
      </main>

      <footer className="no-print border-t border-[#1E2F48] mt-16">
        <div className="max-w-[1400px] mx-auto px-6 py-8 flex flex-col md:flex-row gap-4 justify-between items-start md:items-center text-xs">
          <div className="text-slate-400">
            <div className="text-slate-200 font-medium">Talons Inclusion Factory — San Pedro, CA — TalonsInclusionFactory.com</div>
            <div className="mt-1 text-slate-500 font-mono">IP Moat Locked — All Rights Reserved — Tallan J. Acalin, Sole Executive Officer</div>
          </div>
          <div className="flex items-center gap-2 font-tech text-[#C9A961]">
            <span className="w-2 h-2 bg-[#C9A961]" />
            Founder & Systems Architect
          </div>
        </div>
      </footer>
    </div>
  );
}
